export default "__VITE_ASSET__CVoU$fJI__"